import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "honeypot",
    "jsCheck",
    "submit",
    "companyDescription",
    "companyDescriptionCount",
    "productDescription",
    "productDescriptionCount"
  ]

  connect() {
    // Set JS check to indicate JavaScript is enabled
    this.jsCheckTarget.value = "js_enabled"
  }

  updateCharCount(event) {
    const textarea = event.target
    const count = textarea.value.length
    
    if (textarea === this.companyDescriptionTarget) {
      this.companyDescriptionCountTarget.textContent = `${count}/500`
    } else if (textarea === this.productDescriptionTarget) {
      this.productDescriptionCountTarget.textContent = `${count}/500`
    }
  }

  validateSubmit(event) {
    // Check honeypot - if filled, bot detected
    if (this.honeypotTarget.value !== "") {
      event.preventDefault()
      console.warn("Honeypot triggered")
      return false
    }

    // Disable submit button to prevent double submission
    this.submitTarget.disabled = true
    this.submitTarget.innerHTML = `
      <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Processing...
    `

    return true
  }
}
